<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component v-if="item.name === '3'" @addTab2="addTab2()" :is="item.content" :ref="item.ref" @addTab="addTab()" @removeTab="removeTab(item.name)" :lookID='lookID'></component>
      <component v-else :is="item.content" :ref="item.ref" @addTab="addTab()" @removeTab="removeTab(item.name)" :updataID='updataID'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * 何宽
 * 地学资料查看
 */
import filters from '../method/filter.js'
import DxzlAdd from '../../../../static/form/DxzlAdd'
export default {
  mixins: [filters],
  components: {
    DxzlAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id,
      editableTabsValue: '1',
      editableTabs: [{
        title: '资料库信息',
        name: '1',
        closable: false,
        content: DxzlAdd
      }]
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/DxzlLook'})
      this.$store.commit('onActiveName', tab.name)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/DxzlLook.vue